import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const DCALogo = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/sponsor-logo.png"

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Created By Section */}
        <div className="footer-section">
          <h3 className="footer-title">Created By: DigitalCloudAdvisor</h3>
          <div className="footer-social">
            <FaFacebook className="footer-icon" />
            <span>Follow us on Facebook</span>
          </div>
          <div className="footer-logo">
            <img src={DCALogo} alt="DCA Logo" />
          </div>
        </div>

        {/* Sitemap - Hidden on Mobile */}
        <div className="footer-section footer-hide-mobile">
          <h3 className="footer-title">SITEMAP</h3>
          <ul className="footer-list">
            <li><Link to="/about">About</Link></li>
            <li><Link to="/team">Team</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
          </ul>
        </div>

        {/* Future Events */}
        <div className="footer-section">
          <h3 className="footer-title">FUTURE EVENTS</h3>
          <ul className="footer-list">
            <li>Cupa 5Plus1 UK London</li>
            <li>Astro Arena Cup</li>
            <li>Astro Arena Cup</li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3 className="footer-title">CONTACT</h3>
          <p><FaPhone className="footer-icon" />(0044) 785 289 7207</p>
          <p><FaEnvelope className="footer-icon" />Info@fcgladiatorsbmth.com</p>
          <p><FaMapMarkerAlt className="footer-icon" />Bournemouth, United Kingdom</p>
        </div>
      </div>

      <div className="footer-bottom">
        © Copyright 2022 - Gladiators Football Team
      </div>
    </footer>
  );
};

export default Footer;
